module.exports = __webpack_public_path__ + "img/recruit_5.04df8bd9.png";